import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Icon } from "@azim-crm/icons";
import styles from "./Toast.module.css";
const toneIcon = {
    success: "check",
    warning: "alertTriangle",
    danger: "alertTriangle",
    info: "bell",
};
/**
 * Toast do Azim CRM.
 * Controlado externamente: o consumidor decide quando montar/desmontar
 * (sem fila global) e o dismiss automático é opcional via `durationMs`.
 */
export function Toast({ tone = "info", message, durationMs, onDismiss, className }) {
    const onDismissRef = useRef(onDismiss);
    onDismissRef.current = onDismiss;
    useEffect(() => {
        if (!durationMs)
            return;
        // onDismiss lido via ref: o timer não deve reiniciar a cada re-render do
        // pai só porque ele passou uma nova identidade de função (ex.: arrow
        // function inline sem useCallback) — só `durationMs` deve reagendar.
        const timer = setTimeout(() => onDismissRef.current(), durationMs);
        return () => clearTimeout(timer);
    }, [durationMs]);
    const cls = [styles.toast, styles[tone], className ?? ""].filter(Boolean).join(" ");
    return (_jsxs("div", { className: cls, role: "status", "aria-live": "polite", children: [_jsx(Icon, { name: toneIcon[tone], size: 16 }), _jsx("span", { className: styles.message, children: message }), _jsx("button", { type: "button", className: styles.dismiss, onClick: onDismiss, "aria-label": "Fechar aviso", children: _jsx(Icon, { name: "x", size: 14 }) })] }));
}
//# sourceMappingURL=Toast.js.map